export default {
  lineItems: {
    max: {}
  },
  exportedLineItems: '',
  displayMode: 'display',
  isWaterfallValid: true,
  invalidLineItems: {}
}
